<div class="feedback-dialog">
  <div class="dialog-header">
    <div class="dialog-title">
      {{ isReadOnly ? "Event manager feedback" : "Manager feedback" }}
    </div>
    <button type="button" class="close-button" (click)="onCancel()">
      &times;
    </button>
  </div>

  <ng-container *ngIf="isReadOnly; else editableFeedback">
    <div class="readonly-card">
      <div class="readonly-header">
        <div>
          <div class="readonly-author">
            {{ data.updatedByName || data.eventManagerName }}
          </div>
          <div class="readonly-role">Event Manager</div>
        </div>
        <div class="readonly-time" *ngIf="data.updatedAt">
          {{ data.updatedAt | brisbaneDate: "dd/MM/yyyy, h:mm a" }}
        </div>
      </div>
      <div
        class="readonly-content"
        [class.readonly-content-empty]="!data.feedback"
      >
        {{ data.feedback || "" }}
      </div>
    </div>
  </ng-container>

  <ng-template #editableFeedback>
    <form [formGroup]="form" class="dialog-body">
      <textarea
        formControlName="feedback"
        class="feedback-textarea"
        placeholder="Add your feedback"
        maxlength="100"
        rows="5"
      ></textarea>
    </form>
  </ng-template>

  <div class="dialog-actions">
    <button
      type="button"
      class="cancel-button"
      (click)="onCancel()"
      [disabled]="loading"
    >
      Cancel
    </button>
    <button
      *ngIf="!isReadOnly"
      type="button"
      class="submit-button"
      (click)="onSubmit()"
      [disabled]="loading"
    >
      {{ loading ? "Saving..." : "Submit feedback" }}
    </button>
  </div>
</div>
